// extracted by mini-css-extract-plugin
export default {"container":"fq-z","brandName":"gq-z","productName":"hq-z","productNamePdpEnhancements":"iq-z","breakLongProductName":"jq-z"};